export default "__VITE_ASSET__32538fca__"